import { $app } from '@app/app.service'
import { Action, ActionReducer, createReducer, on } from '@ngrx/store'
import * as StageActions from './stage.actions'
import { initialStageState, StageState } from './stage.state'

const stageReducer = createReducer(
   initialStageState,
   on(StageActions.setUser, (state, action) => {
      return { ...state, user: action.user }
   }),
   on(StageActions.setProject, (state, action) => {
      return { ...state, project: null }
   }),
   on(StageActions.setProjectSuccess, (state, action) => {
      return { ...state, project: action.project }
   })
)

export function reducer(state: StageState | undefined, action?: Action) {
   return stageReducer(state, action)
}

//-- MetaReducer --//

export function stageMetaReducer(reducer: ActionReducer<any>): ActionReducer<any> {
   return function (state, action) {
      if (action.type.startsWith('[stage]')) {
         switch (action.type) {
            case StageActions.setProjectError.type:
               $app.core.notify.error('project_not_exist', 'project_not_exist')
               $app.core.goToRoute('/error')
               break
         }
      }

      return reducer(state, action)
   }
}

